<template>
  <div
    v-if="useMask"
    class="maskStyle"
    :style="`mask-image: url(https://cdn.ecoonline.com/assets/icons/${iconName}.svg); height: ${size}px; width: ${size}px;`"
  />
  <img
    v-else-if="iconName !== ''"
    :src="`https://cdn.ecoonline.com/assets/icons/${iconName}.svg`"
    :class="iconClass"
    :alt="iconName"
    v-bind="customSize"
  >
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: null
    },
    color: {
      type: Boolean,
      default: false
    },
    iconClass: {
      type: String,
      default: ''
    },
    useMask: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customSize () {
      if (!this.size) return {}
      return {
        width: this.size,
        height: this.size
      }
    },
    iconName () {
      const colorSuffix = this.color ? 'color' : 'bw'
      return `${this.name}_${colorSuffix}`
    }
  }
}
</script>

<style lang="postcss" scoped>
  .maskStyle {
    margin-right: 0.5rem;
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
  }
</style>
